import { ExternalLinkIcon } from 'lucide-react';
import Link from 'next/link';
import { cn } from '~/lib/utils';

export const CustomLink = ({ children, className, ...props }: any) => {
  const { href } = props;
  const isInternalLink = href && (href.startsWith('/') || href.startsWith('#'));

  if (!href) {
    <a className={cn('cursor-pointer', className)} {...props}>
      {children}
    </a>;
  }

  if (isInternalLink) {
    return (
      <Link href={href} className={className} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a target="__blank" rel="noopener noreferrer" className={cn('whitespace-nowrap', className)} {...props}>
      {children}
      <ExternalLinkIcon className="mb-2 ml-1 inline h-3 w-3" />
    </a>
  );
};
